import React, { Component } from 'react';
import Sticky from 'Components/Sticky';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { ReactComponent as BackIcon } from 'Icons/back.svg';
import { GET_RFQ_DETAIL, GET_TRIPS } from 'Constants/actionConstants';
import { TRANSPORTER, RFQ_PROV_DISPLAY_LIMIT } from 'Constants/commonConstants';
// import KPTLImg from 'Icons/kptl-logo.png';
import LogoImg  from 'Icons/Logo.jpg';
import Pdf from "react-to-pdf";
import { numberWithCommas } from 'Utils';
import Moment from 'moment';
import ActionLoader from 'Components/ActionLoader/index';
import { getUser } from 'Utils/storage';

const pdfRef = React.createRef();

class TransporterPOFormat extends Component {
    constructor(){
        super();
        this.state = {

        }
    }

    componentDidMount() {
        this.fetchRfq();
        this.getTrips();
    }

    fetchRfq = () => {
        const { dispatch, match } = this.props;
        dispatch({
           type: GET_RFQ_DETAIL,
           params: {
              rfqId: match.params.id,
              rfqType: match.params.type,
              whoami: TRANSPORTER
           }
        });
    }

    getTrips = () => {
        const { dispatch, match } = this.props;
        dispatch({
           type: GET_TRIPS,
           params: {
              isFirstLoad: true,
              rfqId: match.params.id,
              rfqType: match.params.type,
              limit: RFQ_PROV_DISPLAY_LIMIT, // this.props.tripsCount ? RFQ_PROV_DISPLAY_LIMIT : 1000, // isFirstLoad ? 10 : (RFQ_DISPLAY_LIMIT),
              offset: 0,
              whoami: TRANSPORTER,
           }
        })
    }

    getSeekerBids = () => {
		const { dispatch, match } = this.props;
		dispatch({
			type: FETCH_SEEKER_BIDS,
			params: {
				rfqId: match.params.id,
				rfqType: match.params.type,
				limit: RFQ_DISPLAY_LIMIT,
                type: match.params.approverType || undefined
			}
        })
	}

    getDetails = () => {
        const { trips, match, rfq } = this.props;
        let total = 0, bid = {};

        return (
            <>
                {!rfq && <ActionLoader fixed={true} />}
                <div className={'col-1 ph-20 flex flex-middle'}>
                    <div className={'col-2 inBlock'}>
                        <img src={LogoImg} alt="" width='300' className={'ml-10'} height={'100'}/>
                    </div>
                    <div className={'col-2 inBlock tCenter'}>
                        {/* <div className={'fBold fs-16'}>{'KALPATARU POWER TRANSMISSION LTD.'}</div>
                        <div className={'mt-5 fs-14'}>Immeuble Hajal Massad Centre, 3rd Floor</div>
                        <div className={'mt-5 fs-14'}>Chambre 302 / 303, Carrefour Warda,</div>
                        <div className={'mt-5 fs-14'}>Yaounde, Republic of Cameroon</div> */}
                        <div className={'fBold fs-16'}>{'ABC LTD.'}</div>
                        <div className={'mt-5 fs-14'}>Bangalore, Karnataka, India</div>
                    </div>
                </div>
                
                {rfq && (trips || []).length > 0 && 
                <>
                <div className="mt-20 ph-20 pr-table col-1">
                <table cellPadding="0" cellSpacing="0" width="98%">
                    <tbody>
                    <tr><th style={{ 'borderRight': '1px solid grey'}}>{`PR REF:- ${rfq.requisitionNumber} /  / ${rfq.prDate && Moment(rfq.prDate).format('DD.MM.YYYY')}`}</th></tr>
                        <tr><th style={{ 'borderRight': '1px solid grey', 'textAlign': 'left'}}>PURCHASE ORDER</th></tr>
                        <tr><th style={{ 'borderRight': '1px solid grey', 'textAlign': 'left'}}>{getUser().companyName}</th></tr>
                        <tr><th style={{ 'borderRight': '1px solid grey', 'textAlign': 'left'}}>{'We are please to place the order for the below mentioned items.'}</th></tr>
                        <tr><th style={{ 'borderRight': '1px solid grey', 'textAlign': 'left', 'padding': '10px'}}></th></tr>
                    </tbody>
                </table>
                </div>
                <div className="ph-20 pr-table col-1">
                    <table cellPadding="0" cellSpacing="0" width="98%">
                        <thead>
                        <tr>
                            <th>Sr No.</th>
                            <th>Description</th>
                            <th>UOM</th>
                            <th>Quantity</th>
                            <th>Rate</th>
                            <th>Total Amount</th>
                            <th>PR No.</th>
                            <th style={{ 'borderRight': '1px solid grey'}}>Location</th>
                        </tr>
                        </thead>
                        <tbody>
                        {(trips || []).map((trip, tripIndex) => {
                        total += (trip.total_estimated_qty || 0) * (trip.price || 0);
                        return ( <tr key={tripIndex}>
                            <td>{tripIndex + 1}</td>
                            <td>{trip.material_code_description || 0}</td>
                            <td>{trip.uom || 0}</td>
                            <td>{trip.total_estimated_qty || 0}</td>
                            <td>{trip.price}</td>
                            <td>{(trip.total_estimated_qty || 0) * (trip.price || 0) && numberWithCommas((trip.total_estimated_qty || 0) * (trip.price || 0))}</td>
                            <td>{rfq.pr_number || '-'}</td>
                            <td style={{ 'borderRight': '1px solid grey'}}>{rfq.location || '-'}</td>
                        </tr>)})}
                        <tr>
                            <th colSpan="4"></th>
                            <th>Total</th>
                            <th>{total && numberWithCommas(total)}</th>
                            <td colSpan="2" style={{ 'borderRight': '1px solid grey'}}></td>
                        </tr>
                        <tr>
                            <th colSpan="4"></th>
                            <th>TVA</th>
                            <th>{}</th>
                            <td colSpan="2" style={{ 'borderRight': '1px solid grey'}}></td>
                        </tr>
                        <tr>
                            <th colSpan="4"></th>
                            <th>Total TTC</th>
                            <th>{total && numberWithCommas(total)}</th>
                            <td colSpan="2" style={{ 'borderRight': '1px solid grey'}}></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className="mt-20 ph-20 pr-table col-1">
                <table cellPadding="0" cellSpacing="0" width="98%">
                    <tbody>
                        <tr><th style={{ 'borderRight': '1px solid grey', 'textAlign': 'left'}}>Delivery Period: {rfq.deliveryDays.value} {' '} {rfq.deliveryDays.name}</th></tr>
                        <tr><th style={{ 'borderRight': '1px solid grey', 'textAlign': 'left'}}>Payment Terms: {rfq.payment_terms_name}</th></tr>
                        <tr><th style={{ 'borderRight': '1px solid grey', 'textAlign': 'left'}}>Mode Of Dispatch: {rfq.rfqDetails.serviceModeName}</th></tr>
                        <tr><th style={{ 'borderRight': '1px solid grey', 'textAlign': 'left'}}>Dispatch Destination: {rfq.dispatchDestination}</th></tr>
                        <tr><th style={{ 'borderRight': '1px solid grey', 'textAlign': 'left'}}>Contact Person: {rfq.contactPersonAtSite} {' '} {rfq.contactPersonNumberAtSite}</th></tr>
                    </tbody>
                </table>
                </div>
                {/* <div className="mt-20 ph-20 pr-table col-1">
                <table cellPadding="0" cellSpacing="0" width="98%">
                    <thead>
                        <th>
                            <div>Reviewed By</div>
                            <div>(Project Manager)</div>
                        </th>
                        <th>
                            <div>Reviewed By</div>
                            <div>(Commerical)</div>
                        </th>
                        <th>
                            <div>Approved By</div>
                            <div>(Country Head)</div>
                        </th>
                        <th style={{ 'borderRight': '1px solid grey'}}>
                            <div>Accepted By</div>
                            <div>(Vendor)</div>
                        </th>
                    </thead>
                    <tbody>
                        <td>
                            <div><b>{bid.bid_approved_status[0] && bid.bid_approved_status[0].approved_by}</b></div>
                            <div>{bid.bid_approved_status[0] && bid.bid_approved_status[0].loi_approved_date && Moment(bid.bid_approved_status[0].loi_approved_date).format('DD MMM YYYY hh:mm a')}</div>
                        </td>
                        <td>
                            <div><b>{bid.bid_approved_status[1] && bid.bid_approved_status[1].approved_by}</b></div>
                            <div>{bid.bid_approved_status[1] && bid.bid_approved_status[1].loi_approved_date && Moment(bid.bid_approved_status[1].loi_approved_date).format('DD MMM YYYY hh:mm a')}</div>
                        </td>
                        <td>
                            <div><b>{bid.bid_approved_status[2] && bid.bid_approved_status[2].approved_by}</b></div>
                            <div>{bid.bid_approved_status[2] && bid.bid_approved_status[2].loi_approved_date && Moment(bid.bid_approved_status[2].loi_approved_date).format('DD MMM YYYY hh:mm a')}</div>
                        </td>
                        <td style={{ 'borderRight': '1px solid grey'}}>
                            <div><b>{bid.isLoiSent && bid.isAccept && bid.transporterName}</b></div>
                            <div>{bid.loi_accepted_date && Moment(bid.loi_accepted_date).format('DD MMM YYYY hh:mm a')}</div>
                        </td>
                    </tbody>
                </table>
                </div> */}
                </>
            }
            </>
        )
    }

    render() {
        const { rfq, trips } = this.props;
        const vendorTotal = {};
        return (
            <Sticky>
                {rfq && <Link className="ht-40 flex pl-40 wt-200 pt-10" to={"/rfq/details/" + rfq.id + "/" + rfq.type}>
                    <BackIcon className="mr-10 fill-theme curP"/>
                    <div className="header-dark-color fs-16 fBold">{rfq.rfqDetails.name}</div>
                </Link>}
                <div className={'pv-20 mr-20 ml-20 col-1 box-shadow'} >
                    {this.getDetails()}
                </div>
                <div className="pl-40 pf col-1 b-0 ht-60 box-shadow bg-white z-6">
                    <div className="flex flex-middle flex-between ht-60">
                        <Pdf id="pdf-button" targetRef={pdfRef} filename="po_format.pdf" options={{
                            orientation: 'landscape'
                        }}>
                            {({ toPdf }) => <button className={"ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30"} onClick={toPdf}>Download</button>}
                        </Pdf>
                    </div>
                    {<div style={{'width': '87%'}} ref={pdfRef}>
                        {this.getDetails()}
                    </div>}
                </div>
            </Sticky>
        )
    }
}

const mapStateToProps = ({ rfq }) => {
    return {
        rfq: rfq.createdRFQ,
        trips: rfq.trips.data,
    }
}

export default connect(mapStateToProps)(TransporterPOFormat);
